import React from "react";
import "./style.css";

export const UnderlinedTitle = ({text, className}) => {
  return (
    <div className={`underlined_title ${className ? className : ""}`}>
      {text}
    </div>
  );
};
